import { Button } from "@/components/ui/button";
import { LAUNCH_PAD_QUICK_ACTIONS, QUICK_ACTION_LIMIT } from "@/components/launch_pad/launchPadConfig";
import { setLaunchPadOpenNewChat } from "@/lib/launchPadIntent";
import type { User } from "@/context/UserProvider";
import type { ActiveSection, LaunchPadNavigateOptions } from "@/types/appNavigation";

type LaunchPadQuickActionsProps = {
  user: User;
  onNavigate: (section: ActiveSection, options?: LaunchPadNavigateOptions) => void;
};

export function LaunchPadQuickActions({ user, onNavigate }: LaunchPadQuickActionsProps) {
  const actions = LAUNCH_PAD_QUICK_ACTIONS.filter((a) => a.isEnabled(user)).slice(0, QUICK_ACTION_LIMIT);

  if (actions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2" data-testid="launch-pad-quick-actions">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <Button
            key={action.id}
            type="button"
            variant={action.id === "new-chat" ? "default" : "secondary"}
            className="gap-2"
            onClick={() => {
              if (action.openNewResearchChat) {
                setLaunchPadOpenNewChat("research_assistant");
              }
              onNavigate(action.section);
            }}
          >
            <Icon className="h-4 w-4" aria-hidden />
            {action.label}
          </Button>
        );
      })}
    </div>
  );
}
